<template>
    <div v-if="show" class="p-4 mb-5 bg-red-600 text-white">
        <div class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            {{ message }}
        </div>
    </div>
</template>


<script lang="ts">

import {defineComponent} from "vue";

export default defineComponent({

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        message: {
            type: String,
            required: true
        }
    },

    setup(){
    }
});
</script>